import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <div className="hero-section">
        <h1 className="main-title">龙腾铁路服务器</h1>
        <h2 className="sub-title">Longteng Railway Server</h2>
      </div>
      <div className="team-section">
        <h3 className="team-title">服务器团队</h3>
        <div className="team-info">
          <p className="founder"><strong>腐竹：</strong>lmk</p>
          <p className="admins"><strong>管理员：</strong>SS9G-0155, 氮化物只读存储器, 何意味, ff, Yuebian, Yomi_307, 郁琪Yuqi, .</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
